import { useViewport } from '@chilecompra/react-kit'
import { Typography } from '@chilecompra/react-kit/components'

import { Image404, Root } from './NotFound.styles'

/**
 * The NotFound container.
 */
const NotFound = () => {
  const { size } = useViewport()

  return (
    <Root>
      <Typography variant={size.isDownToMedium ? 'h3' : 'h2'}>
        La página solicitada no existe
      </Typography>

      <Image404 alt="La página solicitada no existe" loading="lazy" src="/assets/images/404.svg" />
    </Root>
  )
}

export default NotFound
